// Shared display helpers for the bill-projection chart, ledger and readouts

// Estimate-coarse rounding so figures read as estimates, not quotes
export const roundFive = (value: number): number => Math.round(value / 5) * 5;
export const roundHundred = (value: number): number => Math.round(value / 100) * 100;
export const roundFiveHundred = (value: number): number => Math.round(value / 500) * 500;

// Round to one decimal place so a compounded fraction doesn't render as +6.71586716%
export const roundedPercent = (fraction: number, formatPercent: (value: number) => string): string =>
  formatPercent(Math.round(fraction * 1000) / 1000);

export const signedPercent = (fraction: number, formatPercent: (value: number) => string): string =>
  `${fraction >= 0 ? '+' : ''}${roundedPercent(fraction, formatPercent)}`;

// "an 8 kW", "an 11 kW", "an 18 kW" — every other size in the 3–12 kW range takes "a"
export const kwWithArticle = (kw: number): string => `${[8, 11, 18].includes(Math.floor(kw)) ? 'an' : 'a'} ${kw} kW`;

// ISO date → "August 20, 2026". Split by hand: new Date('2026-08-20') parses as
// UTC midnight and renders the 19th in US time zones
export const formatBenchmarkDate = (isoDate: string): string => {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
};
